import { LineItem } from '../model/line-item';
import { ApiCrud } from './api-crud';
import http from './http';

const lineItemsApi = new ApiCrud(http.AXIOS, LineItem, '/ios/:planId/lineItems');

lineItemsApi.add({
  calculateCpm: 'POST /ios/:planId/lineItems/:id/calculateCpm',
  getAllLineItems: 'GET /ios/lineItems',

  getLineItem: 'GET /ios/lineItem/:id',

  updateFlag: 'PUT ios/:planId/lineItems/:lineItemId/updateFlag',

  sendEmailNotification: 'POST /ios/:id/sendEmailNotification',

  customEmailNotification: 'POST /ios/:id/customEmailNotification',

  sendResubmitEmailNotification: 'POST /ios/:planId/:id/sendResubmitEmailNotification',

  lineItemStatusCount: '/ios/plan/lineItemStatusCount',
});

export default lineItemsApi;
